// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MediaCard.css */

/* ========================================
   MEDIA CARD LOCAL TOKENS
   ======================================== */

:root {
  --scl--cms-components-mediaCard-bg-from:          rgba(252, 252, 252, 0.70);
  --scl--cms-components-mediaCard-bg-to:            rgba(252, 252, 252, 0.56);
  --scl--cms-components-mediaCard-border-color:     #F4F4F4;
  --scl--cms-components-mediaCard-border-radius:    5px;
  --scl--cms-components-mediaCard-backdrop-blur:    16px;

  --scl--cms-components-mediaCard-width:            277px;
  --scl--cms-components-mediaCard-height:           212px;
  --scl--cms-components-mediaCard-padding:          8px;
  --scl--cms-components-mediaCard-inner-radius:     5px;

  --scl--cms-components-mediaCard-title-color:      var(--neutralcolors-100);
  --scl--cms-components-mediaCard-title-size:       var(--font-size-12);
  --scl--cms-components-mediaCard-title-lh:         var(--line-height-18);
  --scl--cms-components-mediaCard-size-color:       #DBDBDB;
  --scl--cms-components-mediaCard-size-font:        10px;
  --scl--cms-components-mediaCard-size-lh:          var(--line-height-18);

  --scl--cms-components-mediaCard-btn-size:         19.47px;
  --scl--cms-components-mediaCard-btn-radius:       4px;
  --scl--cms-components-mediaCard-btn-bg:           transparent;
  --scl--cms-components-mediaCard-btn-bg-hover:     #FFFFFF80;
  --scl--cms-components-mediaCard-btn-color:        var(--neutralcolors-100);
  --scl--cms-components-mediaCard-btn-color-hover:  var(--input-hover);
  --scl--cms-components-mediaCard-btn-delete-color: var(--secondarycolors-red400);
  --scl--cms-components-mediaCard-btn-delete-color-active: var(--primarypalette-red);

  --scl--cms-components-mediaCard-divider-color:    rgba(50, 53, 57, 0.10);
  --scl--cms-components-mediaCard-divider-height:   17px;
}

/* ========================================
   CARD ROOT
   ======================================== */

.scl--cms-components-mediaCard {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: var(--scl--cms-components-mediaCard-height);
  padding: var(--scl--cms-components-mediaCard-padding);
  background: linear-gradient(
    180deg,
    var(--scl--cms-components-mediaCard-bg-from) 0%,
    var(--scl--cms-components-mediaCard-bg-to) 100%
  );
  border: 1px solid var(--scl--cms-components-mediaCard-border-color);
  box-shadow:
    0px 252px 101px rgba(0, 0, 0, 0.01),
    0px 142px  85px rgba(0, 0, 0, 0.02),
    0px  63px  63px rgba(0, 0, 0, 0.04),
    0px  16px  35px rgba(21, 32, 30, 0.04);
  backdrop-filter: blur(var(--scl--cms-components-mediaCard-backdrop-blur));
  -webkit-backdrop-filter: blur(var(--scl--cms-components-mediaCard-backdrop-blur));
  border-radius: var(--scl--cms-components-mediaCard-border-radius);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-inter, 'Inter', sans-serif);
}

/* ========================================
   IMAGE CONTAINER
   ======================================== */

.scl--cms-components-mediaCard-imageContainer {
  position: relative;
  width: 100%;
  height: 196px;
  border-radius: var(--scl--cms-components-mediaCard-inner-radius);
  overflow: hidden;
  flex: 1;
}

/* ========================================
   IMAGE
   ======================================== */

.scl--cms-components-mediaCard-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--scl--cms-components-mediaCard-inner-radius);
  display: block;
}

/* ========================================
   BADGE
   ======================================== */

.scl--cms-components-mediaCard-badge {
  position: absolute;
  width: 27px;
  height: 27px;
  left: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.scl--cms-components-mediaCard-badge--visible {
  opacity: 1;
}

/* ========================================
   GRADIENT MASK
   ======================================== */

.scl--cms-components-mediaCard-gradientMask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 56px;
  background: linear-gradient(181.9deg, rgba(104, 102, 102, 0) -15.46%, #000000 98.82%);
  border-radius: 0 0 var(--scl--cms-components-mediaCard-inner-radius) var(--scl--cms-components-mediaCard-inner-radius);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.scl--cms-components-mediaCard-gradientMask--visible {
  opacity: 1;
}

/* ========================================
   INFO ROW
   ======================================== */

.scl--cms-components-mediaCard-infoRow {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 8px;
  display: flex;
  flex-direction: row;
  opacity: 0;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  transition: opacity 0.25s ease;
}

.scl--cms-components-mediaCard-infoRow--visible {
  opacity: 1;
}

/* ========================================
   TEXT
   ======================================== */

.scl--cms-components-mediaCard-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  margin-right: 8px;
}

.scl--cms-components-mediaCard-title {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-style: normal;
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--scl--cms-components-mediaCard-title-size);
  line-height: var(--scl--cms-components-mediaCard-title-lh);
  color: var(--scl--cms-components-mediaCard-title-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.scl--cms-components-mediaCard-size {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-style: normal;
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--scl--cms-components-mediaCard-size-font);
  line-height: var(--scl--cms-components-mediaCard-size-lh);
  color: var(--scl--cms-components-mediaCard-size-color);
}

/* ========================================
   ACTION BUTTONS
   ======================================== */

.scl--cms-components-mediaCard-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.scl--cms-components-mediaCard-actionBtn {
  width: var(--scl--cms-components-mediaCard-btn-size);
  height: var(--scl--cms-components-mediaCard-btn-size);
  background: var(--scl--cms-components-mediaCard-btn-bg);
  border: none;
  border-radius: var(--scl--cms-components-mediaCard-btn-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
  color: var(--scl--cms-components-mediaCard-btn-color);
}

.scl--cms-components-mediaCard-actionBtn--view {
  color: var(--scl--cms-components-mediaCard-btn-color);
}

.scl--cms-components-mediaCard-actionBtn--edit {
  color: var(--scl--cms-components-mediaCard-btn-color);
}

.scl--cms-components-mediaCard-actionBtn--delete {
  color: var(--scl--cms-components-mediaCard-btn-delete-color);
}

.scl--cms-components-mediaCard-actionBtn--view:hover,
.scl--cms-components-mediaCard-actionBtn--edit:hover {
  color: var(--scl--cms-components-mediaCard-btn-color-hover);
  background: var(--scl--cms-components-mediaCard-btn-bg-hover);
}

.scl--cms-components-mediaCard-actionBtn--delete:hover {
  background: var(--secondarycolors-red100);
  color: var(--scl--cms-components-mediaCard-btn-delete-color);
}

.scl--cms-components-mediaCard-actionBtn--delete:active {
  color: var(--scl--cms-components-mediaCard-btn-delete-color-active);
}

/* ========================================
   DIVIDER
   ======================================== */

.scl--cms-components-mediaCard-divider {
  width: 1px;
  height: var(--scl--cms-components-mediaCard-divider-height);
  background: var(--scl--cms-components-mediaCard-divider-color);
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/card-fs-cp/media-card-op/css/mediaCard.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;6CAE6C;;AAE7C;EACE,2EAA2E;EAC3E,2EAA2E;EAC3E,yDAAyD;EACzD,qDAAqD;EACrD,sDAAsD;;EAEtD,uDAAuD;EACvD,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;;EAErD,0EAA0E;EAC1E,qEAAqE;EACrE,uEAAuE;EACvE,yDAAyD;EACzD,sDAAsD;EACtD,uEAAuE;;EAEvE,yDAAyD;EACzD,qDAAqD;EACrD,6DAA6D;EAC7D,2DAA2D;EAC3D,0EAA0E;EAC1E,oEAAoE;EACpE,+EAA+E;EAC/E,kFAAkF;;EAElF,wEAAwE;EACxE,sDAAsD;AACxD;;AAEA;;6CAE6C;;AAE7C;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mDAAmD;EACnD,qDAAqD;EACrD;;;;GAIC;EACD,mEAAmE;EACnE;;;;0CAIwC;EACxC,yEAAyE;EACzE,iFAAiF;EACjF,iEAAiE;EACjE,aAAa;EACb,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gEAAgE;EAChE,gBAAgB;EAChB,OAAO;AACT;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gEAAgE;EAChE,cAAc;AAChB;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,qFAAqF;EACrF,sHAAsH;EACtH,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,4CAA4C;EAC5C,0DAA0D;EAC1D,0DAA0D;EAC1D,uDAAuD;EACvD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,4CAA4C;EAC5C,yDAAyD;EACzD,yDAAyD;EACzD,sDAAsD;AACxD;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;EACrD,uDAAuD;EACvD,YAAY;EACZ,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,2DAA2D;EAC3D,6DAA6D;AAC/D;;AAEA;EACE,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,mEAAmE;AACrE;;AAEA;;6CAE6C;;AAE7C;EACE,UAAU;EACV,2DAA2D;EAC3D,8DAA8D;EAC9D,cAAc;AAChB","sourcesContent":["/* MediaCard.css */\n\n/* ========================================\n   MEDIA CARD LOCAL TOKENS\n   ======================================== */\n\n:root {\n  --scl--cms-components-mediaCard-bg-from:          rgba(252, 252, 252, 0.70);\n  --scl--cms-components-mediaCard-bg-to:            rgba(252, 252, 252, 0.56);\n  --scl--cms-components-mediaCard-border-color:     #F4F4F4;\n  --scl--cms-components-mediaCard-border-radius:    5px;\n  --scl--cms-components-mediaCard-backdrop-blur:    16px;\n\n  --scl--cms-components-mediaCard-width:            277px;\n  --scl--cms-components-mediaCard-height:           212px;\n  --scl--cms-components-mediaCard-padding:          8px;\n  --scl--cms-components-mediaCard-inner-radius:     5px;\n\n  --scl--cms-components-mediaCard-title-color:      var(--neutralcolors-100);\n  --scl--cms-components-mediaCard-title-size:       var(--font-size-12);\n  --scl--cms-components-mediaCard-title-lh:         var(--line-height-18);\n  --scl--cms-components-mediaCard-size-color:       #DBDBDB;\n  --scl--cms-components-mediaCard-size-font:        10px;\n  --scl--cms-components-mediaCard-size-lh:          var(--line-height-18);\n\n  --scl--cms-components-mediaCard-btn-size:         19.47px;\n  --scl--cms-components-mediaCard-btn-radius:       4px;\n  --scl--cms-components-mediaCard-btn-bg:           transparent;\n  --scl--cms-components-mediaCard-btn-bg-hover:     #FFFFFF80;\n  --scl--cms-components-mediaCard-btn-color:        var(--neutralcolors-100);\n  --scl--cms-components-mediaCard-btn-color-hover:  var(--input-hover);\n  --scl--cms-components-mediaCard-btn-delete-color: var(--secondarycolors-red400);\n  --scl--cms-components-mediaCard-btn-delete-color-active: var(--primarypalette-red);\n\n  --scl--cms-components-mediaCard-divider-color:    rgba(50, 53, 57, 0.10);\n  --scl--cms-components-mediaCard-divider-height:   17px;\n}\n\n/* ========================================\n   CARD ROOT\n   ======================================== */\n\n.scl--cms-components-mediaCard {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: var(--scl--cms-components-mediaCard-height);\n  padding: var(--scl--cms-components-mediaCard-padding);\n  background: linear-gradient(\n    180deg,\n    var(--scl--cms-components-mediaCard-bg-from) 0%,\n    var(--scl--cms-components-mediaCard-bg-to) 100%\n  );\n  border: 1px solid var(--scl--cms-components-mediaCard-border-color);\n  box-shadow:\n    0px 252px 101px rgba(0, 0, 0, 0.01),\n    0px 142px  85px rgba(0, 0, 0, 0.02),\n    0px  63px  63px rgba(0, 0, 0, 0.04),\n    0px  16px  35px rgba(21, 32, 30, 0.04);\n  backdrop-filter: blur(var(--scl--cms-components-mediaCard-backdrop-blur));\n  -webkit-backdrop-filter: blur(var(--scl--cms-components-mediaCard-backdrop-blur));\n  border-radius: var(--scl--cms-components-mediaCard-border-radius);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n}\n\n/* ========================================\n   IMAGE CONTAINER\n   ======================================== */\n\n.scl--cms-components-mediaCard-imageContainer {\n  position: relative;\n  width: 100%;\n  height: 196px;\n  border-radius: var(--scl--cms-components-mediaCard-inner-radius);\n  overflow: hidden;\n  flex: 1;\n}\n\n/* ========================================\n   IMAGE\n   ======================================== */\n\n.scl--cms-components-mediaCard-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--scl--cms-components-mediaCard-inner-radius);\n  display: block;\n}\n\n/* ========================================\n   BADGE\n   ======================================== */\n\n.scl--cms-components-mediaCard-badge {\n  position: absolute;\n  width: 27px;\n  height: 27px;\n  left: 10px;\n  top: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.scl--cms-components-mediaCard-badge--visible {\n  opacity: 1;\n}\n\n/* ========================================\n   GRADIENT MASK\n   ======================================== */\n\n.scl--cms-components-mediaCard-gradientMask {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 56px;\n  background: linear-gradient(181.9deg, rgba(104, 102, 102, 0) -15.46%, #000000 98.82%);\n  border-radius: 0 0 var(--scl--cms-components-mediaCard-inner-radius) var(--scl--cms-components-mediaCard-inner-radius);\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.scl--cms-components-mediaCard-gradientMask--visible {\n  opacity: 1;\n}\n\n/* ========================================\n   INFO ROW\n   ======================================== */\n\n.scl--cms-components-mediaCard-infoRow {\n  position: absolute;\n  left: 6px;\n  right: 6px;\n  bottom: 8px;\n  display: flex;\n  flex-direction: row;\n  opacity: 0;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 2;\n  transition: opacity 0.25s ease;\n}\n\n.scl--cms-components-mediaCard-infoRow--visible {\n  opacity: 1;\n}\n\n/* ========================================\n   TEXT\n   ======================================== */\n\n.scl--cms-components-mediaCard-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n  margin-right: 8px;\n}\n\n.scl--cms-components-mediaCard-title {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-style: normal;\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--scl--cms-components-mediaCard-title-size);\n  line-height: var(--scl--cms-components-mediaCard-title-lh);\n  color: var(--scl--cms-components-mediaCard-title-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.scl--cms-components-mediaCard-size {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-style: normal;\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--scl--cms-components-mediaCard-size-font);\n  line-height: var(--scl--cms-components-mediaCard-size-lh);\n  color: var(--scl--cms-components-mediaCard-size-color);\n}\n\n/* ========================================\n   ACTION BUTTONS\n   ======================================== */\n\n.scl--cms-components-mediaCard-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-mediaCard-actionBtn {\n  width: var(--scl--cms-components-mediaCard-btn-size);\n  height: var(--scl--cms-components-mediaCard-btn-size);\n  background: var(--scl--cms-components-mediaCard-btn-bg);\n  border: none;\n  border-radius: var(--scl--cms-components-mediaCard-btn-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n  flex-shrink: 0;\n  color: var(--scl--cms-components-mediaCard-btn-color);\n}\n\n.scl--cms-components-mediaCard-actionBtn--view {\n  color: var(--scl--cms-components-mediaCard-btn-color);\n}\n\n.scl--cms-components-mediaCard-actionBtn--edit {\n  color: var(--scl--cms-components-mediaCard-btn-color);\n}\n\n.scl--cms-components-mediaCard-actionBtn--delete {\n  color: var(--scl--cms-components-mediaCard-btn-delete-color);\n}\n\n.scl--cms-components-mediaCard-actionBtn--view:hover,\n.scl--cms-components-mediaCard-actionBtn--edit:hover {\n  color: var(--scl--cms-components-mediaCard-btn-color-hover);\n  background: var(--scl--cms-components-mediaCard-btn-bg-hover);\n}\n\n.scl--cms-components-mediaCard-actionBtn--delete:hover {\n  background: var(--secondarycolors-red100);\n  color: var(--scl--cms-components-mediaCard-btn-delete-color);\n}\n\n.scl--cms-components-mediaCard-actionBtn--delete:active {\n  color: var(--scl--cms-components-mediaCard-btn-delete-color-active);\n}\n\n/* ========================================\n   DIVIDER\n   ======================================== */\n\n.scl--cms-components-mediaCard-divider {\n  width: 1px;\n  height: var(--scl--cms-components-mediaCard-divider-height);\n  background: var(--scl--cms-components-mediaCard-divider-color);\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
